import React from 'react';
import { Link } from 'react-router-dom';
import LiveBadge from './LiveBadge';

export default function PageHero({ breadcrumb, headline, accentText, sub, badge, bgImage }) {
  return (
    <section
      data-testid="page-hero"
      style={{
        background: 'var(--bg)',
        position: 'relative',
        overflow: 'hidden',
        paddingTop: 86,
      }}
    >
      {/* Background image (transparent overlay) */}
      {bgImage && (
        <>
          <div style={{
            position: 'absolute', inset: 0,
            backgroundImage: `url(${bgImage})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            opacity: .22,
            pointerEvents: 'none',
          }} />
          <div style={{
            position: 'absolute', inset: 0,
            background: 'linear-gradient(to bottom, var(--bg) 0%, transparent 30%, transparent 70%, var(--bg) 100%)',
            pointerEvents: 'none',
          }} />
        </>
      )}

      {/* Ambient glow */}
      <div
        style={{
          position: 'absolute',
          top: '40%',
          left: '15%',
          transform: 'translate(-50%,-50%)',
          width: 600,
          height: 400,
          background: 'radial-gradient(ellipse, rgba(229,51,51,.06) 0%, transparent 70%)',
          pointerEvents: 'none',
        }}
      />
      <div
        style={{
          position: 'absolute',
          bottom: 0,
          left: 0,
          right: 0,
          height: 1,
          background: 'var(--border)',
        }}
      />

      <div className="wrap" style={{ position: 'relative', zIndex: 1, padding: '3.5rem 1.5rem 3rem' }}>
        {/* Breadcrumb */}
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '.5rem',
            fontSize: '.78rem',
            color: 'var(--text2)',
            marginBottom: '1.25rem',
          }}
        >
          <Link to="/" style={{ transition: 'color .2s' }}
            onMouseEnter={e => e.currentTarget.style.color = 'var(--blue)'}
            onMouseLeave={e => e.currentTarget.style.color = 'var(--text2)'}>
            Anasayfa
          </Link>
          <span style={{ color: 'var(--muted)', fontSize: '.65rem' }}>/</span>
          <span style={{ color: 'var(--blue)' }}>{breadcrumb}</span>
        </div>

        {/* Live badge */}
        <div style={{ marginBottom: '1rem' }}>
          <LiveBadge text={badge || 'Şu An Aktif — Hizmet Veriyoruz'} />
        </div>

        {/* Headline */}
        <h1
          style={{
            fontFamily: "'Space Grotesk', sans-serif",
            fontWeight: 800,
            fontSize: 'clamp(2rem, 5vw, 3.25rem)',
            color: 'var(--text)',
            lineHeight: 1.06,
            letterSpacing: '-.035em',
            marginBottom: '.875rem',
          }}
        >
          {headline}
          {accentText && (
            <>
              <br />
              <span style={{ color: 'var(--blue)' }}>{accentText}</span>
            </>
          )}
        </h1>

        {/* Sub */}
        {sub && (
          <p
            style={{
              fontSize: 'clamp(.875rem, 1.5vw, 1rem)',
              color: 'var(--text2)',
              lineHeight: 1.72,
              maxWidth: 540,
            }}
          >
            {sub}
          </p>
        )}
      </div>
    </section>
  );
}
